import { Texture, TilingSprite } from 'pixi.js';

/**
 * Halftone grain as a single static overlay texture, tiled — one draw call,
 * never per-sprite (§10). It's the thing that stops flat fills reading as
 * "vector art" and starts them reading as "printed".
 */
export function makeGrainTexture(size = 128, density = 0.5): Texture {
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) return Texture.WHITE;

  const img = ctx.createImageData(size, size);
  // A fixed pattern, not Math.random per session — the grain should be the
  // same print every time the game loads.
  let s = 0x2f6b3d1;
  for (let i = 0; i < size * size; i++) {
    s = (Math.imul(s ^ (s >>> 15), s | 1) + 0x6d2b79f5) >>> 0;
    const n = ((s >>> 8) & 0xff) / 255;
    const on = n < density ? 0 : 1;
    const v = on ? 0 : 255;
    img.data[i * 4 + 0] = v;
    img.data[i * 4 + 1] = v;
    img.data[i * 4 + 2] = v;
    img.data[i * 4 + 3] = on ? 0 : 26;
  }
  ctx.putImageData(img, 0, 0);
  return Texture.from(canvas);
}

export function makeGrainOverlay(width: number, height: number): TilingSprite {
  const sprite = new TilingSprite({
    texture: makeGrainTexture(),
    width,
    height,
  });
  sprite.alpha = 0.5;
  sprite.eventMode = 'none';
  return sprite;
}
